module.exports = __webpack_public_path__ + "img/hgMainLanding.616d7a21.jpg";